// extracted by mini-css-extract-plugin
export default {"input":"input_input__7gqJD","icon":"input_icon__rYuf2","wrap":"input_wrap__whxqh"};